import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiCheckCircle } = FiIcons;

const Merci = () => {
  const location = useLocation();

  useEffect(() => {
    const eventPayload = {
      'send_to': 'AW-1038828953/rk35CKv62_IbEJmLre8D',
    };

    // Check if enhanced conversion data is present in the location state
    if (location.state?.enhancedConversionData) {
      eventPayload.enhanced_conversion_data = location.state.enhancedConversionData;
    }

    // Send the conversion event to Google Ads
    if (window.gtag) {
      window.gtag('event', 'conversion', eventPayload);
    }
  }, [location.state]); // Effect depends on location state

  return (
    <div className="min-h-screen bg-white font-sans text-[#004d44] flex flex-col">
      <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md shadow-sm py-4">
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          <a href="/#/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 rounded-lg bg-[#00a48c] text-white flex items-center justify-center font-black">S</div>
            <span className="text-xl font-black tracking-tight">Simulation Rendement PER</span>
          </a>
        </div>
      </nav>

      <main className="flex-grow flex items-center justify-center pt-20 pb-20 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <div className="w-24 h-24 rounded-full bg-[#f0fcf9] text-[#00a48c] flex items-center justify-center mx-auto mb-8 border-4 border-white shadow-lg">
              <SafeIcon icon={FiCheckCircle} size={48} />
            </div>
            <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight text-[#004d44] mb-4">Merci !</h1>
            <p className="text-lg text-gray-600 font-medium mb-10 leading-relaxed">
              Votre demande a bien été prise en compte. Un de nos conseillers experts vous contactera dans les plus brefs délais pour discuter de votre projet.
            </p>
            <a
              href="/#/"
              className="inline-flex items-center gap-3 bg-[#00a48c] text-white px-8 py-4 rounded-full font-black shadow-xl hover:bg-[#00856f] transition-all text-sm uppercase tracking-widest"
            >
              <SafeIcon icon={FiArrowLeft} /> Retour à l'accueil
            </a>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Merci;
